// QuirkyLoadingMessages.js
// A collection of fun, playful loading messages for chart placeholders

const quirkyLoadingMessages = [
    // Data-related messages
    "Unscrambling available data...",
    "Preparing your FDBK...",
    "Counting all the yes and no's...",
    "Making sense of the numbers...",
    "Turning data into insights...",
    "Crunching the numbers...",
    "Reading between the data points...",
    "Connecting the data dots...",
    "Turning spreadsheets into magic...",
    "De-confusing the data...",
    
    // Chart-related messages
    "Drawing pretty charts for you...",
    "Coloring inside the lines...",
    "Preparing the perfect pixels...",
    "Making charts look fancy...",
    "Teaching the charts to dance...",
    "Polishing the graph edges...",
    "Aligning all the charts just right...",
    "Adding chart sparkle ✨...",
    
    // Fun tech messages
    "Summoning the chart wizard...",
    "Checking the data crystal ball...",
    "Consulting the data oracle...",
    "Spinning up the insight machine...",
    "Feeding hamsters powering the server...",
    "Calculating at ludicrous speed...",
    "Reticulating splines...",
    "Warming up the data oven...",
    "Untangling the data spaghetti...",
    
    // Customer-focused messages
    "Finding your happy customers...",
    "Gathering all the smiles...",
    "Reading customer minds...",
    "Measuring happiness levels...",
    "Scanning for customer joy...",
    "Converting feedback to insights...",
    "Finding patterns in feedback...",
    
    // Seasonal/themed messages (you can rotate these based on time of year)
    "Sprinkling data fairy dust...",
    "Adding a dash of data magic...",
    "Brewing your insights potion...",
    "Weaving insights from feedback..."
  ];
  
  // Function to get a random message
  export const getRandomLoadingMessage = () => {
    const randomIndex = Math.floor(Math.random() * quirkyLoadingMessages.length);
    return quirkyLoadingMessages[randomIndex];
  };
  
  // Function to get a new message every few seconds (for animation)
  export const createMessageRotator = (setMessageCallback, intervalMs = 3000) => {
    // Set initial message
    setMessageCallback(getRandomLoadingMessage());
    
    // Set up interval to change message
    const intervalId = setInterval(() => {
      setMessageCallback(getRandomLoadingMessage());
    }, intervalMs);
    
    // Return function to clear interval when done
    return () => clearInterval(intervalId);
  };
  
  export default quirkyLoadingMessages;